import {
  login,
  logout,
  getUserApi,
  listUser,
  listSkillGroup,
  getUserGroupTree,
  bplogout,
  getAgentInfo,
  getRolePermission,
  getOrderPermission,
  getAllQuickReplys,
  getShortcutKeyById
} from '@/api/user'
import { http } from '@/utils/http.js'
import globalVaribale from '@/utils/globalVariable'
const defaultWbGroupId = globalVaribale.defaultUserGroupId
const builtinAdminId = globalVaribale.defaultBuiltinAdminId
const getDefaultUserState = () => {
  return {
    authRoutes: [],
    Authorization: localStorage.getItem('Authorization') ? localStorage.getItem('Authorization') : '',
    tenantId: localStorage.getItem('X-TENANT-ID') ? localStorage.getItem('X-TENANT-ID') : '',
    loginUser: {},
    appList: [],
    appAuthDetail: {},
    wbUserList: [],
    curGroupId: defaultWbGroupId, //  当前坐席组选择的节点
    defaultWbGroupId: defaultWbGroupId, //  默认选择组
    curCTRoleId: '', // 坐席管理选择的角色ID
    curCTSearchText: '', // 坐席管理输入的信息
    curModUserId: '', // 坐席管理编辑用户信息
    skillGroupList: [],
    clickSkillGroup: {
      id: ''
    },
    userGroupTree: [], // 坐席组数据，不带坐席人员
    userGroupData: [], // 坐席组数据，带坐席人员
    skillGroupData: [], // 技能组数据
    last1001Time: 0,
    curExpandedKeys: [],
    wbJumpAllow: '',
    curAcdId: '',
    canEditAcd: false,
    acdCache: {},
    blankAcd: {
      id: '',
      acdName: '',
      excludeHoliday: 0,
      extimeServiceType: 1,
      extimeServiceWords: '',
      enableBiz: 0,
      bizChooseErrType: 1,
      bizErrTimeThreshold: null,
      multiSgStrategyId: '8',
      creator: '',
      editor: '',
      createTime: null,
      editTime: null,
      channelIds: [],
      acdTimes: [],
      acdBizs: [],
      acdBizResets: [{
        id: '',
        acdId: '',
        resetTime: '00:00'
      }],
      sysAcdBizGroups: [],
      comSysAcdBizQueue: {
        enableVipFirst: 0,
        vipFirstType: 0,
        vipIntervalNum: 1,
        reportTimeInterval: 60,
        enableWaittingOverflow: 0,
        waitTimeThreshold: 300,
        skillGroupIds: []
      }
    },
    blankAcdTime: {
      id: '',
      foreignKey: '',
      type: 0,
      weekday: null,
      startTime: '',
      endTime: ''
    },
    acdStepIndex: 1,
    acdPageIndex: 1,
    acdTimeForm: {},
    platformApplyAcdPageIndex: 1,
    curPlatformAcdId: '',
    blPageIndex: 1,
    chatHistoryQuery: {
      sessionId: ''
    },
    userInfo: {},
    sessLogQueryTerms: {} // sessionLog页面查询详情时的当前查询条件
  }
}
export default {
  namespaced: true, // 注册为【带命名空间】的模块,这样这个模块下的state,mutations等属性属于【子命名空间】下的局部变量,不会与其他【子命名空间】下的变量冲突。
  state: {
    authRoutes: [],
    Authorization: localStorage.getItem('Authorization') ? localStorage.getItem('Authorization') : '',
    tenantId: localStorage.getItem('X-TENANT-ID') ? localStorage.getItem('X-TENANT-ID') : '',
    loginUser: {},
    appList: [],
    appAuthDetail: {},
    wbUserList: [],
    curGroupId: defaultWbGroupId, // 当前坐席组选择的节点
    defaultWbGroupId: defaultWbGroupId, //  默认选择组
    curCTRoleId: '', // 坐席管理选择的角色ID
    curCTSearchText: '', // 坐席管理输入的信息
    curModUserId: '', // 坐席管理编辑用户信息
    skillGroupList: [],
    clickSkillGroup: {
      id: ''
    },
    userGroupTree: [], // 坐席组数据，不带坐席人员
    userGroupData: [], // 坐席组数据，带坐席人员
    skillGroupData: [], // 技能组数据
    last1001Time: 0,
    curExpandedKeys: [],
    wbJumpAllow: '',
    curAcdId: '',
    canEditAcd: false,
    acdCache: {},
    blankAcd: {
      id: '',
      acdName: '',
      excludeHoliday: 0,
      extimeServiceType: 1,
      extimeServiceWords: '',
      enableBiz: 0,
      bizChooseErrType: 1,
      bizErrTimeThreshold: null,
      multiSgStrategyId: '8',
      creator: '',
      editor: '',
      createTime: null,
      editTime: null,
      channelIds: [],
      acdTimes: [],
      acdBizs: [],
      acdBizResets: [{
        id: '',
        acdId: '',
        resetTime: '00:00'
      }],
      sysAcdBizGroups: [],
      comSysAcdBizQueue: {
        enableVipFirst: 0,
        vipFirstType: 0,
        vipIntervalNum: 1,
        reportTimeInterval: 60,
        enableWaittingOverflow: 0,
        waitTimeThreshold: 300,
        skillGroupIds: []
      }
    },
    blankAcdTime: {
      id: '',
      foreignKey: '',
      type: 0,
      weekday: null,
      startTime: '',
      endTime: ''
    },
    acdStepIndex: 1,
    acdPageIndex: 1,
    acdTimeForm: {},
    platformApplyAcdPageIndex: 1,
    curPlatformAcdId: '',
    qcDetailPageIndex: 1,
    blPageIndex: 1,
    chatHistoryQuery: {
      sessionId: ''
    },
    avatarImgPath: '',
    userInfo: {},
    status,
    quickReplys: {},
    shortcutKey: {},
    sessLogQueryTerms: {} // sessionLog页面查询详情时的当前查询条件
  },
  mutations: {
    SET_ADMIN_ROUTES: (state, { authRoutes }) => {
      state.authRoutes = authRoutes
    },
    setUserInfo(state, { id, userName, nickname, roleId, roleType }) {
      state.loginUser.userId = id
      state.loginUser.userName = userName
      state.loginUser.nickname = nickname
      state.loginUser.roleId = roleId
      state.loginUser.roleType = roleType
    },
    setToken(state, { token, expiresAt }) {
      state.Authorization = token
      localStorage.setItem('Authorization', token)
      localStorage.setItem('expiresAt', expiresAt)
    },
    setTenantId(state, tenantId) {
      state.tenantId = tenantId
      localStorage.setItem('X-TENANT-ID', tenantId)
    },
    setAppList(state, data) {
      state.appList = data.appInfo
    },
    setAppListDetail(state, { appId, authDetail }) {
      state.appAuthDetail[appId] = authDetail
    },
    setWbUserList(state, { data }) {
      state.wbUserList = data
    },
    setCurGroupId(state, { groupId }) {
      state.curGroupId = groupId
    },
    setDefaultCurGroupId(state) {
      state.defaultWbGroupId = defaultWbGroupId
    },
    setCurCTRoleId(state, { roleId }) {
      state.curCTRoleId = roleId
    },
    setCurCTSearchText(state, { searchText }) {
      state.curCTSearchText = searchText
    },
    setCurModUserId(state, { userId }) {
      state.curModUserId = userId
    },
    setSkillGroupList(state, { data }) {
      state.skillGroupList = data
    },
    setClickSkillGroupId(state, { id }) {
      state.clickSkillGroup.id = id
    },
    setUserGroupTree(state, { data }) {
      state.userGroupTree = data
    },
    setUserGroupData(state, { data }) {
      state.userGroupData = data
    },
    setSkillGroupData(state, { data }) {
      state.skillGroupData = data
    },
    setLast1001Time(state, { time }) {
      state.last1001Time = time
    },
    setCurExpandedKeys(state, { keys }) {
      state.curExpandedKeys = keys
    },
    setWBJumpAllow(state, isAllow) {
      state.wbJumpAllow = isAllow
    },
    setAcdCache(state, { acd }) {
      state.acdCache = acd
    },
    setCurAcdId(state, { acdId }) {
      state.curAcdId = acdId
    },
    setCanEditAcd(state, { canEditAcd }) {
      state.canEditAcd = canEditAcd
    },
    setAcdStepIndex(state, { acdStepIndex }) {
      state.acdStepIndex = acdStepIndex
    },
    setAcdPageIndex(state, { acdPageIndex }) {
      state.acdPageIndex = acdPageIndex
    },
    setBlPageIndex(state, { blPageIndex }) {
      state.blPageIndex = blPageIndex
    },
    setChatHistoryQuery(state, { chatHistoryQuery }) {
      state.chatHistoryQuery = chatHistoryQuery
    },
    setAcdTimeForm(state, { acdTimeForm }) {
      state.acdTimeForm = acdTimeForm
    },
    setPlatformApplyAcdPageIndex(state, { platformApplyAcdPageIndex }) {
      state.platformApplyAcdPageIndex = platformApplyAcdPageIndex
    },
    setCurPlatformAcdId(state, { curPlatformAcdId }) {
      state.curPlatformAcdId = curPlatformAcdId
    },
    resetState(state) {
      Object.assign(state, getDefaultUserState())
    },
    setQcDetailPageIndex(state, { qcDetailPageIndex }) {
      state.qcDetailPageIndex = qcDetailPageIndex
    },
    setAvatar(state, avatarPath) {
      state.avatarImgPath = avatarPath
    },
    SET_USERINFO(state, userInfo) {
      state.userInfo = userInfo
    },
    setStatus(state, status) {
      state.status = status
      localStorage.setItem('WORK-STATUS', status)
    },
    setQuickReplys(state, quickReplys) {
      state.quickReplys = quickReplys
    },
    setShortcutKey(state, shortcutKey) {
      state.shortcutKey = shortcutKey
    },
    setSessLogQueryTerms(state, terms) {
      state.sessLogQueryTerms = terms
    }
  },
  actions: {
    // 登录
    handleLogin({ commit }, { tenantId, username, password }) {
      return new Promise((resolve, reject) => {
        login({
          tenantId,
          username,
          password
        }).then(res => {
          if (res && res.data && res.data.code === 2000 && res.data.data.token) {
            // console.log(res.data)
            commit('setToken', { token: res.data.data.token, expiresAt: res.data.data.expiresAt })
            commit('setTenantId', tenantId)
          }
          resolve(res.data)
        }).catch(err => {
          reject(err)
        })
      })
    },
    // 退出登录
    handleLogOut({ state, commit }) {
      return new Promise((resolve, reject) => {
        logout(state.Authorization).then(res => {
          if (res.data.code === 2000) {
            bplogout(state.Authorization).then(res2 => {
              resolve(res2.data)
            }).catch(err => {
              reject(err)
            })
          }
        }).catch(err => {
          reject(err)
        })
      })
    },
    // 获取用户相关信息
    getUser({ state, commit }) {
      return new Promise((resolve, reject) => {
        getUserApi().then(res => {
          const data = res.data.data
          commit('setUserInfo', { id: data.userInfo.id, userName: data.userInfo.userName, nickname: data.userInfo.nickName, roleId: data.userInfo.roles[0].id, roleType: data.userInfo.roles[0].roleType })
          commit('setAppList', data)
          commit('setAppListDetail', { appId: 'aicc-bp', authDetail: data.bp_auth })
          // 判断用户是否有跳转坐席工作台权限
          if (data.userInfo.id !== builtinAdminId) {
            if (data.wb_auth && data.wb_auth.length > 0) {
              data.wb_auth.forEach(item => {
                if (item.path === '/workbench' && item.value === 'true') {
                  commit('setWBJumpAllow', 'true')
                }
              })
            }
          } else {
            commit('setWBJumpAllow', 'false')
          }

          getAgentInfo(data.userInfo.id).then(res2 => {
            const userInfo = res2.data.data.agentData
            if (userInfo) {
              commit('SET_USERINFO', userInfo)

              var groupIds = []
              userInfo.skillGroups.forEach(group => groupIds.push(group.id))
              getAllQuickReplys(userInfo.id, groupIds.slice(',')).then(res3 => {
                commit('setQuickReplys', res3.data.quickReplys)
                getShortcutKeyById(userInfo.id).then(res4 => {
                  commit('setShortcutKey', res4.data)

                  const l = []
                  l.push(data.bp_auth)
                  if (data.appInfo && data.appInfo.length > 0) {
                    const requests = []
                    data.appInfo.forEach((v) => {
                      if (v.appId !== 'aicc-workbench') {
                        const temprequest = new Promise((resolve, reject) => {
                          http.get('/' + v.appId + '/auth/getPermission', { params: { queryType: 1, roleId: data.userInfo.roles[0].id, containsBtn: true, platform: 'aicc_bp' } }).then((res) => {
                            commit('setAppListDetail', { appId: v.appId, authDetail: res.data.data })
                            // TODO 设置其他模块权限保存至vuex
                            resolve(res.data)
                          }).catch(() => {
                            resolve([])
                          })
                        })
                        requests.push(temprequest)
                      }
                    })
                    Promise.all(requests).then((res) => {
                      if (res && res.length !== 0) {
                        res.forEach((v, i) => {
                          if (v.data) {
                            l.push(v.data)
                          }
                        })
                      }
                      resolve(l)
                    }).catch(() => {
                    })
                  } else {
                    resolve(l)
                  }
                }).catch(err => {
                  reject(err)
                })
              }).catch(err => {
                reject(err)
              })
            }
          }).catch(err => {
            reject(err)
          })
        }).catch(err => {
          reject(err)
        })
      })
    },
    // // 获取用户相关信息
    // getUser({ state, commit }) {
    //   return new Promise((resolve, reject) => {
    //     getUserApi().then(res => {
    //       const data = res.data.data
    //       commit('setUserInfo', { id: data.userInfo.id, userName: data.userInfo.userName, nickname: data.userInfo.nickName, roleId: data.userInfo.roles[0].id, roleType: data.userInfo.roles[0].roleType })
    //       commit('setAppList', data)
    //       commit('setAppListDetail', { appId: 'aicc-bp', authDetail: data.bp_auth })
    //       // 判断用户是否有跳转坐席工作台权限
    //       if (data.userInfo.id !== builtinAdminId) {
    //         data.wb_auth.forEach(item => {
    //           if (item.path === '/workbench' && item.value === 'true') {
    //             commit('setWBJumpAllow', 'true')
    //           }
    //         })
    //       } else {
    //         commit('setWBJumpAllow', 'false')
    //       }

    //       getAgentInfo(data.userInfo.id).then(res2 => {
    //         const userInfo = res2.data.data.agentData
    //         if (userInfo) {
    //           commit('SET_USERINFO', userInfo)

    //           const l = []
    //           l.push(data.bp_auth)
    //           if (data.appInfo && data.appInfo.length > 0) {
    //             const requests = []
    //             data.appInfo.forEach((v) => {
    //               const temprequest = new Promise((resolve, reject) => {
    //                 http.get('/' + v.appId + '/auth/getPermission', { params: { queryType: 1, roleId: data.userInfo.roles[0].id, containsBtn: true, platform: 'aicc_bp' } }).then((res) => {
    //                   commit('setAppListDetail', { appId: v.appId, authDetail: res.data.data })
    //                   // TODO 设置其他模块权限保存至vuex
    //                   resolve(res.data)
    //                 }).catch(() => {
    //                   resolve([])
    //                 })
    //               })
    //               requests.push(temprequest)
    //             })
    //             Promise.all(requests).then((res) => {
    //               if (res && res.length !== 0) {
    //                 res.forEach((v, i) => {
    //                   if (v.data) {
    //                     l.push(v.data)
    //                   }
    //                 })
    //               }
    //               resolve(l)
    //             }).catch(() => {
    //             })
    //           } else {
    //             resolve(l)
    //           }
    //         }
    //       }).catch(err => {
    //         reject(err)
    //       })
    //     }).catch(err => {
    //       reject(err)
    //     })
    //   })
    // },
    _listUser({ state, commit }, { groupId, pageNum, pageSize, paramRoleId, forceUserRole }) {
      groupId = groupId || state.curGroupId
      // const tRoleId = paramRoleId || forceUserRole ? paramRoleId : state.curCTRoleId
      let tRoleId
      if (forceUserRole) {
        tRoleId = paramRoleId
      } else if (!paramRoleId) {
        tRoleId = state.curCTRoleId
      }
      // const tRoleId = paramRoleId
      return new Promise((resolve, reject) => {
        listUser({ groupId, roleId: tRoleId, searchText: state.curCTSearchText, pageNum, pageSize })
          .then(res => {
            if (res.code === 2000) {
              if (res.data.list && res.data.list.length > 0) {
                const idx = res.data.list.findIndex(item => item.id === builtinAdminId)
                if (idx !== -1) {
                  res.data.list.splice(idx, 1)
                }
              }
              commit('setWbUserList', { data: res.data.list })
              resolve(res)
            }
          })
          .catch(() => {
          })
      })
    },
    _listSkillGroup({ state, commit }) {
      listSkillGroup()
        .then(res => {
          if (res.code === 2000) {
            commit('setSkillGroupList', { data: res.data })
          }
        })
        .catch(() => {
        })
    },
    /**
     * 获取userGroup数据
     * type = 0  只获取组织树，不带坐席人员
     * type = 1  获取组织树+坐席人员
     */
    _getUserGroupTree({ state, commit }, { type }) {
      getUserGroupTree(type)
        .then(res => {
          if (res.code === 2000) {
            if (type === '1') {
              commit('setUserGroupData', { data: res.data })
            } else {
              commit('setUserGroupTree', { data: res.data })
            }
          }
        })
        .catch(() => {
        })
    }
  },
  getRolePermission({ state, commit }) {
    return new Promise((resolve, reject) => {
      try {
        getRolePermission(state.Authorization).then(res => {
          const data = res.data
          if (data) {
            commit('setAppListDetail', { appId: 'aicc-bp', authDetail: data.data })
            resolve(data.data)
          } else {
            // reject(new Error('relogin'))
            // localStorage.clear()
            window.location.href = window.$envUtils('VUE_APP_BP_URL')
          }
        })
      } catch (error) {
        reject(error)
      }
    })
  },
  getOrderPermission({ state, commit }) {
    return new Promise((resolve, reject) => {
      try {
        getOrderPermission(state.userInfo.roles[0].id).then(res => {
          const data = res.data
          if (data) {
            resolve(data.data)
          } else {
          }
        }).catch(function() {
          // console.log(error)
          resolve()// http请求异常时说明工单服务未开启
        })
      } catch (error) {
        resolve()
      }
    })
  }
}
